import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface SplitTestProps {
  duplicateFlow: () => void;
  addFlow: () => void;
}

export default function SplitTest({ duplicateFlow, addFlow }: SplitTestProps) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  const Component = isDesktop ? Dialog : Drawer;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger className="flex h-10 items-center rounded-2xl border border-dashed border-black-300 px-4 text-button-sm lg:h-12 lg:px-6 lg:text-button-md">
        <PlusCircle size={20} weight="fill" className="-ml-3 mr-2.5" />
        {isDesktop ? "Create split test" : "Add flow"}
      </Trigger>
      <Content>
        <Header
          title="Duplicate current flow?"
          subtitle="Do you want to copy your current flow or make a new one from scratch?"
        />

        <Footer className="justify-end">
          <Button
            variant="outline-black"
            onClick={() => {
              addFlow();
              setIsOpen(false);
            }}
          >
            Create new
          </Button>

          <Button
            onClick={() => {
              duplicateFlow();
              setIsOpen(false);
            }}
          >
            Duplicate flow
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
